import Vue from 'vue';
import { mutationTypes, actionTypes } from '../../types';

export default store => {
	// called when the store is initialized
	// logger.log('styleDevListerne actived Changed');
	store.subscribe((mutation, state) => {
		if (mutation.type === mutationTypes.activeCssMode) {
			// logger.log('styleDevListerne actived Changed');
			const url = new URL(state.styleTemplateURL);
			// logger.log('styleDevListener: Start styleDevListener on url', url);
			// creating devServer websocket url string/
			let lastHash;
			setInterval(async () => {
				const { body } = await Vue.http.get(`${url.origin}/version.html`, { credentials: false });
				if (lastHash !== body) {
					lastHash = body;
					store.dispatch(actionTypes.setStyleUrl, {
						styleTemplateURL: `${state.styleTemplateURL}#${Date.now()}`,
					});
				}
			}, 250);
		}
	});
};
